// ** Redux & Store & Actions
import { useDispatch, useSelector } from "react-redux";
import {
	setActiveTab,
	setRecoverActive,
	setRecoverCurrentStep,
	setRecoverEmail,
	setLastRecoveryEmailSentTime,
} from "store/modules/auth";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import { RecoverButtonStyled } from "containers/Landing/styles/RecoverButton.styled";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";
import Step3 from "./components/Step3";

// #####################################################

const Recover = () => {
	const { t } = useTranslation(["landing"]);

	const dispatch = useDispatch();

	// ** Selectors
	const currentStep = useSelector((state) => state.auth.recover.currentStep);
	const emailRecover = useSelector(
		(state) => state.auth.recover.emailRecover
	);

	// #####################################################

	return (
		<>
			{currentStep === "first" ? (
				<Step1
					currentStep={currentStep}
					setCurrentStep={(step) =>
						dispatch(setRecoverCurrentStep(step))
					}
					setEmailRecover={(email) =>
						dispatch(setRecoverEmail(email))
					}
					setLastRecoveryEmailSentTime={(time) =>
						dispatch(setLastRecoveryEmailSentTime(time))
					}
				/>
			) : null}
			{currentStep === "second" ? (
				<Step2 currentStep={currentStep} emailRecover={emailRecover} />
			) : null}
			{currentStep === "third" ? (
				<Step3 currentStep={currentStep} />
			) : null}
			<Block flex justifyEnd mt={4}>
				<RecoverButtonStyled
					onMouseDown={() => {
						dispatch(setRecoverActive(false));
						dispatch(setActiveTab("login"));
					}}
				>
					{t("landing:recover.goToLogin")}
				</RecoverButtonStyled>
			</Block>
		</>
	);
};

export default Recover;

// #####################################################
